export const USE_LOCAL_ENDPOINTS = true;
